import { render, staticRenderFns } from "./StudentTrainList.vue?vue&type=template&id=dae86eb2&scoped=true"
import script from "./StudentTrainList.vue?vue&type=script&lang=js"
export * from "./StudentTrainList.vue?vue&type=script&lang=js"
import style0 from "./StudentTrainList.vue?vue&type=style&index=0&id=dae86eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae86eb2",
  null
  
)

export default component.exports